"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushDatalayerInformation = void 0;
var react_1 = __importStar(require("react"));
var useCookieConsent_1 = __importDefault(require("@empiriecom/module-components/hooks/useCookieConsent"));
// eslint-disable-next-line import/no-cycle
var __1 = require("..");
var pushDatalayerInformation = function (advisorCode) {
    window.dataLayer.push({
        event: 'renderSmartAssistantScript',
        eventValue: {
            smartAssistantAdvisorCode: advisorCode,
        },
    });
};
exports.pushDatalayerInformation = pushDatalayerInformation;
var SmartAssistant = function (_a) {
    var advisorCode = _a.advisorCode;
    var isSmartAssistantAllowed = useCookieConsent_1.default('C0002');
    react_1.useEffect(function () { return (isSmartAssistantAllowed && exports.pushDatalayerInformation(advisorCode)) || undefined; }, [
        isSmartAssistantAllowed,
    ]);
    return react_1.default.createElement("div", { id: "advisor-container", "data-testid": __1.CustomScriptTestIds.SmartAssistantScript });
};
exports.default = SmartAssistant;
//# sourceMappingURL=SmartAssistant.js.map